import { WorldpayCustomisationPage } from '../../models/worldpay/worldpay-customisation-page.interface';
import { mockWorldpayCustomisationBorder } from './worldpay-customisation-border.mock';

export const mockWorldpayCustomisationPage: WorldpayCustomisationPage = {
  backgroundColor: '#00000',
  border: mockWorldpayCustomisationBorder,
  color: '#00000',
  fonts: [],
};
